import { Container } from '@bit/ui-common.ui-components/ss-components';
import { injectLinkConfig } from '../../../utils/helpUtils';
import HelpData from '@bit/ui-common.ui-components/ss-common-data/react/components/help/HelpData';
import { getPathParams } from '@bit/ui-common.ui-components/ss-utils/utils/commonUtils';

const id = 'afsp-help-application-guide';

export default Container({
    state: s => ({ commonData: s.commonData }),
    services: []
},
    class ApplicationGuide extends React.Component {
        constructor(props) {
            super(props);
        }
        componentDidMount() { injectLinkConfig(id) };

        render() {
            const { space, theme } = this.props;
            let namedDest;
            let defaultPdf;
            const guideLookupTable = {
                candidate: '/home/CandidateGuide.pdf',
                provider: '/home/ProviderGuide.pdf',
                other: '/home/OtherGovernmentUsersGuide.pdf'
            }

            const params = getPathParams();
            if (params != null && params.namedDest != null) {
                namedDest = params.namedDest;
            }

            if (params != null && params.guide != null) {
                defaultPdf = guideLookupTable[params.guide]
            }

            const pdfs = [
                {
                    filePath: guideLookupTable.candidate,
                    fileName: 'Candidate Guide',
                },
                {
                    filePath: guideLookupTable.provider,
                    fileName: 'Provider and Small Entity Compliance Guide',
                },
                {
                    filePath: guideLookupTable.other,
                    fileName: 'Other Government User Guide',
                },
            ]

            return (
                <HelpData
                        title={'User Guides'}
                        space={space || null}
                        theme={theme || null}
                        pdfs={pdfs}
                        defaultPdf={defaultPdf || guideLookupTable.candidate}
                />
            );
        }
    })
